var cssImage = {"imageBase":"Image-module_imageBase__FcqAo"};

export { cssImage as default };
